import { render } from "./SoloImage.vue?vue&type=template&id=124d109d"
import script from "./SoloImage.vue?vue&type=script&lang=js"
export * from "./SoloImage.vue?vue&type=script&lang=js"

import "./SoloImage.vue?vue&type=style&index=0&id=124d109d&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__